import { loginRequest } from "./loginRequest";
import { msalInstance } from "./msalInstance";

export function redirectToLogin(): Promise<void> {
    return msalInstance.loginRedirect(loginRequest);
}
